export const brandCaptionLowerThirdIsDefault = {
  type: "boolean"
};
